// Core
import {
	Component,
	ElementRef,
	Input,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';

// Types
import {
	ProfileCompletionStatus,
	TodoItem,
} from '../../../interfaces/profile-completion.interface';
import { UserService } from '../../../services/user.service';

// Services

@Component({
	selector: 'app-profile-completion-section',
	templateUrl: './profile-completion-section.component.html',
	styleUrls: [
		'./circle-progress.scss',
		'./profile-completion-section.component.scss',
	],
	encapsulation: ViewEncapsulation.None,
})
export class ProfileCompletionSectionComponent implements OnInit {
	@Input() type: string;
	@Input() title: string;
	@Input() subtitle: string;
	@Input() index: number;
	@Input() hideDivider: boolean;
	@Input() isUserActive: boolean;
	@Input() todos: readonly TodoItem[];
	@Input() hasBtn = false;
	@Input() status: ProfileCompletionStatus;
	@Input() reset: ReplaySubject<boolean> = new ReplaySubject<boolean>();
	public showBtn = false;
	public showDropdown = true;
	public showGreenTick = false;
	public showClock = false;
	private dropdownState = true;
	public disableBtn = false;
	public isBtnLoading = false;
	public hasAllTodosComplete = false;
	@ViewChild('todoContentDiv', { static: true }) todoContent: ElementRef;
	@ViewChild('dropdownImage') dropdownImg: ElementRef;
	@ViewChild('titleWrapperDiv', { static: true }) titleDiv: ElementRef;

	constructor(
		private userService: UserService,
		private translate: TranslateService,
		private notificationService: ZkNotificationService
	) {}

	ngOnInit(): void {
		const hasAllTodosComplete = this.todos.every((todo) => todo.completed);
		this.hasAllTodosComplete = hasAllTodosComplete;

		if (this.status) {
			if (!hasAllTodosComplete) {
				this.showDropdown = true;
				this.titleDiv.nativeElement.classList.add('clickable');
				this.disableBtn = !this.status.previousStepDone;
			} else if (hasAllTodosComplete) {
				this.showClock = true;
				this.disableBtn = true;
			} else if (hasAllTodosComplete) {
				this.showGreenTick = true;
				this.disableBtn = true;
			}
		} else {
			if (hasAllTodosComplete) {
				this.showGreenTick = true;
			} else {
				this.showDropdown = true;
				this.titleDiv.nativeElement.classList.add('clickable');
			}
		}

		if (!hasAllTodosComplete) {
			this.disableBtn = true;
		}

		setTimeout(() => {
			this.showTodos();
		}, 10);
	}

	showTodos() {
		if (!this.showDropdown) {
			return;
		}
		this.dropdownImg.nativeElement?.classList[
			this.dropdownState ? 'add' : 'remove'
		]('invert');
		this.todoContent.nativeElement?.classList[
			this.dropdownState ? 'add' : 'remove'
		]('expand');
		this.showBtn = !this.showBtn;
		this.dropdownState = !this.dropdownState;
	}

	requestActivate() {
		this.isBtnLoading = true;
		this.userService.requestActivation().subscribe(
			(response) => {
				if (response.requestedActivation) {
					this.showDropdown = false;
					this.showGreenTick = false;
					this.disableBtn = true;
					this.showClock = true;
				}
				this.reset.next(true);
				this.isBtnLoading = false;
			},
			(error) => {
				this.isBtnLoading = false;
				this.notificationService.showError(error.message);
			}
		);
	}
}
